export function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== "";
}
